import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../../clients/apiClient';
import { connectWebSocket } from './socketConnection';
import { TaskChat } from './chatCommunication';

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  if (!window.name) {
    window.name = crypto.randomUUID(); // Generate a unique windowId for the current tab
  }
  
  const ws = useRef(null);
  var { taskId } = useParams();
  const navigate = useNavigate();

  console.log('[SocketProvider] taskId_id', taskId);
  const [messages, setMessages] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [pinnedTasks, setPinnedTasks] = useState([]);
  const keepAliveInterval = useRef(null); // Ref to store interval ID
  const [currentTask, setCurrentTask] = useState(null);
  const [systemErrorMessage, setSystemErrorMessage] = useState(null);

  console.log("[WebSocket] tasks and filteredTasks", tasks, filteredTasks);

  const refreshTasks = () => {
    console.log("[WebSocket] refreshing tasks")
    apiClient.get('/').then(({ data }) => {
      console.log("[WebSocket] refreshed tasks", data.tasks)
      setTasks(data.tasks);
      setFilteredTasks(data.tasks);
      setPinnedTasks(data.pinned_tasks);
      const myTask = data.tasks?.find((task) => task.id === taskId);
      let messages = myTask ? myTask.messages : []
      if (messages.length === 0) {
        const myPinnedTask = data.pinnedTasks?.find((task) => task.id === taskId )
        messages = myPinnedTask ? myPinnedTask.messages : []
      }
      setMessages(messages);
    });
  };
  
  const getTaskIdFromMessage = (messageData) => {
    switch (messageData.type) {
      case "simple_message": return messageData?.simple_message?.task_id
      case "simple_html_message": return messageData?.simple_html_message?.task_id
      case "action_message": return messageData?.action_message?.task_id
      case "planner_message": return messageData?.planner_message?.task_id
      case "error": return messageData?.error?.task_id
    }
  }
  let isRefreshing = false;

  window.addEventListener('beforeunload', () => {
    isRefreshing = true; // Set refresh flag
    ws.current?.close();      // Close the socket explicitly
  });

  function stopKeepAlivePings() {
    if (keepAliveInterval.current) {
      clearInterval(keepAliveInterval.current); // Clear interval
      keepAliveInterval.current = null; // Reset ref
    }
  }

  function newReceivedMessage(messageData) {
    console.log("[WebSocket] new message received", messageData);
    if (messageData?.type === 'system_error') {
      setSystemErrorMessage(messageData.system_error?.message);
      return;
    } else if (taskId === getTaskIdFromMessage(messageData)) {
      setMessages((prevMessages) => {
        var allPrevMessages = [];
        for (let i=0; i<prevMessages.length; i++) {
          if (!prevMessages[i].is_temporary) {
            allPrevMessages = [...allPrevMessages, prevMessages[i]]
          }
        }
        console.log("[WebSocket] allMessages are", [...allPrevMessages, messageData])
        return [...allPrevMessages, messageData]
      });
    }
  }

  useEffect(() => {

    connectWebSocket(ws, keepAliveInterval, stopKeepAlivePings, newReceivedMessage, isRefreshing);

    return () => {
      if (ws.current) ws.current.close();
      stopKeepAlivePings(); // Clear interval on unmount
    };
  }, [taskId]);

  React.useEffect(() => {
    apiClient.get('/').then(({ data }) => {
      setTasks(data.tasks);
      setFilteredTasks(data.tasks);
      setPinnedTasks(data.pinned_tasks);
      const myTask = data.tasks?.find((task) => task.id === taskId);
      let messages = myTask ? myTask.messages : []
      if (messages.length === 0) {
        const myPinnedTask = data.pinnedTasks?.find((task) => task.id === taskId )
        messages = myPinnedTask ? myPinnedTask.messages : []
      }
      setMessages(messages);
    });
  }, [taskId]);

  return (
    <WebSocketContext.Provider
      value={{ 
        messages, 
        sendMessage: (message) => TaskChat(setTasks, setFilteredTasks, setMessages, taskId, navigate).sendMessage(message), 
        systemErrorMessage, 
        firstChatMessage: (message, task_name) => {TaskChat(setTasks, setFilteredTasks, setMessages, taskId, navigate).firstTaskChatMessage(message, task_name)}, 
        filterTasks: (searchTerm) => TaskChat(setTasks, setFilteredTasks, setMessages, taskId, navigate).filterTasks(tasks, searchTerm),
        tasks: filteredTasks, 
        pinnedTasks, 
        currentTask, 
        refreshTasks 
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
